<template>
  <div
    class="shape-coupon-Rectangle1"
    :class="{ disabled: !isTimeVis }"
    v-bind:aria-disabled="true"
  >
    <!-- <div class="timeout"  :class="{ 'timeout-show': !card.isTimeVis }"  >หมดเวลา</div> -->

    <svg
      width="315"
      viewBox="0 0 315 133"
      class="shape-coupon-Rectangle2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_0_1)">
        <path
          d="M1 6.79716C1 3.04319 4.2948 0 8.35915 0H306.641C310.705 0 314 3.0432 314 6.79717V29.2761C314 33.4506 309.796 36.6 305.487 37.8587C301.128 39.1319 296.727 42.3409 296.727 50.1093C296.727 57.7605 300.996 60.9004 305.289 62.1235C309.67 63.3716 314 66.5278 314 70.7624V124.203C314 127.957 310.705 131 306.641 131H8.35916C4.29482 131 1 127.957 1 124.203V70.4522C1 66.3233 5.04418 63.1559 9.41678 62.2973C14.6413 61.2715 20.3662 58.2827 20.3662 50.1093C20.3662 41.8467 14.5156 38.7743 9.24586 37.6828C4.94063 36.7911 1 33.6372 1 29.562V6.79716Z"
          fill="url(#paint0_linear_0_1)"
          shape-rendering="crispEdges"
        />
      </g>
      <path
        d="M1.3 6.79716C1.3 3.23087 4.43761 0.3 8.35915 0.3H306.641C310.562 0.3 313.7 3.23088 313.7 6.79717V29.2761C313.7 31.2551 312.705 33.0116 311.156 34.4403C309.606 35.8697 307.522 36.9518 305.403 37.5708C303.186 38.2182 300.938 39.3637 299.244 41.3538C297.546 43.3483 296.427 46.1647 296.427 50.1093C296.427 53.994 297.513 56.764 299.169 58.7208C300.823 60.6737 303.023 61.7897 305.207 62.412C307.363 63.0261 309.497 64.1078 311.086 65.5455C312.675 66.9826 313.7 68.7552 313.7 70.7624V124.203C313.7 127.769 310.562 130.7 306.641 130.7H8.35916C4.43762 130.7 1.3 127.769 1.3 124.203V70.4522C1.3 68.4925 2.25871 66.744 3.77041 65.3704C5.28333 63.9958 7.33608 63.0116 9.47458 62.5917C12.1153 62.0732 14.9122 61.0537 17.0526 59.1055C19.2032 57.1481 20.6662 54.2751 20.6662 50.1093C20.6662 45.8978 19.1711 42.9823 16.9845 40.9854C14.808 38.9977 11.9695 37.9406 9.30671 37.389C7.20171 36.9531 5.19132 35.9645 3.7122 34.596C2.23429 33.2287 1.3 31.4965 1.3 29.562V6.79716Z"
        stroke="url(#paint1_linear_0_1)"
        stroke-width="0.6"
        stroke-linejoin="round"
      />
      <g filter="url(#filter1_b_0_1)">
        <line
          x1="27"
          y1="45.6817"
          x2="288"
          y2="45.6818"
          stroke="#B6B6B6"
          stroke-dasharray="7 7"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_0_1"
          x="0"
          y="0"
          width="315"
          height="133"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.54 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_0_1"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_0_1"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_b_0_1"
          x="23"
          y="41.1817"
          width="269"
          height="9.00002"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_0_1"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_0_1"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_0_1"
          x1="157.5"
          y1="0"
          x2="157.5"
          y2="131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.74" />
          <stop offset="1" stop-color="#DDE1FF" stop-opacity="0.98" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_1"
          x1="165.5"
          y1="4.61817"
          x2="147.955"
          y2="131.565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#10567E" stop-opacity="0.81" />
          <stop offset="0.333333" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <div class="shape-coupon-header">{{ datacard.cou_name }}    </div>
    <div class="shape-coupon-header2">{{ datacard.cou_name }}</div>
    <!-- <div class="shape-coupon-line1"></div> -->
    <div class="shape-coupon-image1">
      <!-- {{ getImageUrl(datacard.cou_type_bg) }} -->
      <img
        class="img-in-card-l2 responsive"
        :src="getImageUrl(datacard.cou_type_bg)"  alt="Coupon Background"
      />
    
    </div>
    <div class="shape-coupon-textcoupon">COUPON</div>
    <div class="shape-coupon-price">{{ datacard.cou_price }}.-</div>
    <div class="shape-coupon-img2"></div>
  </div>
  
</template>

<script>
export default {
  name: "CardCoupons",
  props: {
    datacard: {
      type: Object,
      default: () => ({}),
    },
    isTimeVis:{
        type:Boolean,
        default: () => ({}),
    }
  },
  data() {
    return {
        card: [],
    };
  },
  methods:{
    getImageUrl(fileName) {
      if (!fileName) {
        return ""; // return empty string if fileName is undefined or null
      }
      return require(`../../public/Images/coupons/${fileName}`);
    }
  }
};
</script>

<style scoped>
/* ///////// */
.img-in-card-l2 {
  /* position: absolute;
  top: 1px;
  left: 5px; */
  z-index: 2;
  height: 120%;
  opacity: 0.9;
}

@import url("https://fonts.googleapis.com/css2?family=Pattaya&display=swap");

/* Rectangle 1 */

/* Group 1 */
.shape-coupon-group {
  position: absolute;
  width: 313px;
  height: 141.83px;
  left: 3px;
  top: 21px;
}

/* Rectangle 1 */
.shape-coupon-Rectangle1 {
  position: relative;
  transition: 0.5s;
  cursor: pointer;
  max-width: 463px;
}
.shape-coupon-Rectangle1:hover {
    filter: saturate(6.5);
  /* filter: hue-rotate(281deg); */
}
 .disabled:hover {
    filter: saturate(0.5);

}

/* Rectangle 2 */
.shape-coupon-Rectangle2 {
  box-sizing: border-box;
  overflow: hidden;

  width: -webkit-fill-available;
  display: block;
    position: relative;

  /* background: #fff0;
  background-image: url("../../public/Images/coupons/bg/food-seamlessbackground.png");
  background-size: cover; 
  background-repeat: no-repeat;
  background-size: 86%;
  background-position-x: center;
  background-position-y: bottom; */
}
.shape-coupon-Rectangle2::before {
  content: "";
  background-image: url("../../public/Images/coupons/bg/food-seamlessbackground.png"); /* The image used */
  background-size: cover; 
  opacity: 0.2;
  background-size: 86%;
  background-position-x: center;
  background-position-y: bottom; 

  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;

}

/* image 1 */
.shape-coupon-image1 {
  position: absolute;
  width: 58%;
  height: 75%;
  left: 7%;
  /* top: 29%; */
  bottom: 2%;
  /* background: url('https://static.vecteezy.com/system/resources/previews/013/169/101/original/grilled-chicken-and-sticky-rice-thai-food-png.png'); */
  overflow: hidden;
}

/* Line 1 */
.shape-coupon-line1 {
  position: absolute;
  width: 89%;
  height: 0px;
  left: 6%;
  top: 24%;
  border: 2px dashed #d4d4d4;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  /* Note: backdrop-filter has minimal browser support */
}

/* Header */
.shape-coupon-header {
  position: absolute;
  left: 8%;
  top: 4%;

  font-family: "Pattaya", sans-serif;

  font-style: normal;
  font-weight: 200;
  font-size: 9vw;
  line-height: 39px;

  color: #474747;
}

/* Header */
.shape-coupon-header2 {
  position: absolute;
  right: 2%;
  width: 45%;
  top: 39%;
  font-family: "Pattaya", sans-serif;
  font-style: normal;
  font-weight: 200;
  font-size: 4vw;
  line-height: 15px;
  text-align: center;
  color: #3b3b3bb8;
}

/* COUPON */
.shape-coupon-textcoupon {
  position: absolute;
  /* width: 89.65px;
height: 16.73px; */
  right: 10%;
  width: 30%;
  top: 53%;
  font-family: "Inter";
  font-style: italic;
  font-weight: 300;
  /* font-size: 15px; */
  line-height: 18px;
  text-align: center;
  font-size: 5vw;
  color: #979797;
}
@media screen and (min-width: 576px) {
  .shape-coupon-textcoupon {
    font-size: 15px !important;
  }
  .shape-coupon-header {
    font-size: xx-large !important;
    /* top: -2px !important; */
  }
  .shape-coupon-header2 {
    font-size: small !important;
    top: 38 !important;
  }
  .shape-coupon-price {
    font-size: x-large !important;
  }
  .shape-coupon-line1 {
    width: 88%;

    top: 33%;
    border: 1px dashed #d4d4d4;
  }
}

/* 35.- */
.shape-coupon-price {
  position: absolute;
  right: 10%;
  width: 30%;
  top: 68%;

  font-family: "Inter";
  font-style: italic;
  font-weight: 300;
  font-size: 9vw;
  line-height: 29px;
  text-align: center;

  color: #919191;
}

/* image 2 */
.shape-coupon-img2 {
  position: absolute;
  width: 15%;
  height: 20px;
  /* left: 273px; */
  right: 2%;
  /* top: 146px; */
  bottom: 4%;
  /* background: url(https://static.vecteezy.com/system/resources/previews/013/169/101/original/grilled-chicken-and-sticky-rice-thai-food-png.png); */
  background-image: url(data:image/png;base64,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);
  background-size: cover;
  background-repeat: no-repeat;
  background-size: 91%;
  background-position-x: center;
  background-position-y: bottom;
}
.line-coupon {
  border: 2px dashed;
  /* padding: 0; */
  margin-bottom: 8px;
  margin-top: 0;
}
.timeout {
  font-family: "Pattaya", sans-serif;
  position: absolute;
  z-index: 100;
  opacity: 0.5;
  font-size: 7vw;
  display: none;
}
</style>